import { Component, OnInit } from '@angular/core';
import { GridOptions } from "ag-grid/main";
import { Router } from '@angular/router';

@Component({
  selector: 'app-assessment-360',
  templateUrl: './assessment-360.component.html',
  styleUrls: ['./assessment-360.component.scss']
})
export class Assessment360Component implements OnInit {
    assessments: any[] = [];
    assessmentsHeaders: any[];
    gridOptions: GridOptions;
    gridApi;
    gridColumnApi;
    overlayNoRowsTemplate;
    assessmentType: number = 2;

    height: number;
    count: number;

    loading: boolean = true;

    constructor(
        private router: Router,
    ) { this.overlayNoRowsTemplate = "<span>No row to show</span>"; }


    ngOnInit() {
        this.gridOptions = <GridOptions>{};
        this.gridOptions.rowHeight = 45;
        this.gridOptions.headerHeight = 40;

        this.assessmentsHeaders = this.createHeaders();

        this.refresh(); 
    }

    GetAssessmentsbyType() {
        this.loading = true;
        //this._GetAssessmentsByType.getAssessmentsByType(this.assessmentType).subscribe((data: any) => {
        //    console.log('getAssessments', data.result);
        //    if (this._Globals.validationToken(data.result.Result)) {
        //        let _data = JSON.parse(data.result.Data);
        //        this.assessments = _data;
        //        this.loading = false;
        //    }
        //});
    }
    refresh() {
        this.GetAssessmentsbyType();
    }
    onResize(event: any) {
        //console.log("Width: " , event.currentTarget.innerWidth);
        //console.log("Height: " , event.currentTarget.innerHeight);
        setTimeout(() => {
            this.sizeToFit();
        }, 500);
    }

    gridSize(count: number) {
        this.count = count;
        console.log('count', this.count);
        this.height = (this.count + 1) * 43;
    }

    sizeToFit() {
        this.gridApi.sizeColumnsToFit();
        $('.ag-body-viewport').css('overflow', 'overlay');
    }

    onGridReady(params) {
        this.gridApi = params.api;
        this.sizeToFit();
        setTimeout(() => {
            $(".ag-floating-filter-input").attr("placeholder", "Filter");
        }, 100);
    }

    createHeaders() {
        let columnDefs = new Array();

        let idHeader = {
            headerName: 'Id',
            field: 'Id',
            sort: 'asc',
            minWidth: 200,
            width: 200,
            hide: true,
            suppressSizeToFit: false,
            cellRenderer: function (params) {
                return params.value;
            }
        };
        columnDefs.push(idHeader);

        let nameHeader = {
            headerName: 'Name',
            field: 'Name',
            minWidth: 200,
            width: 200,
            suppressSizeToFit: false,
            cellRenderer: function (params) {
                return params.value;
            }
        };
        columnDefs.push(nameHeader);

        //let nicheHeader = {
        //    headerName: 'Niche',
        //    field: 'NicheName',
        //    minWidth: 200,
        //    width: 200,
        //    suppressSizeToFit: false,
        //    cellRenderer: function (params) {
        //        return params.value;
        //    }
        //};
        //columnDefs.push(nicheHeader);

        let versionHeader = {
            headerName: 'Version',
            field: '',
            minWidth: 100,
            width: 100,
            suppressSizeToFit: true,
            cellRenderer: function (params) {
                return params.data.MajorVersion + '.' + params.data.MinorVersion;
            }
        };
        columnDefs.push(versionHeader);

        let actionsHeader = {
            headerName: 'Actions',
            field: '',
            width: 100,
            minWidth: 100,
            suppressSizeToFit: true,
            suppressSorting: true,
            suppressMenu: true,
            cellRenderer: function (params) {
                let content = '';

                content += '<i id="editAction" class="material-icons custom-icons">edit</i>';

                content += '<i id="deleteAction" class="material-icons custom-icons">delete</i>';

                return '<span style="margin-top: 4px !important;position: absolute;">' + content + '</span>';

            }
        };
        columnDefs.push(actionsHeader);

        return columnDefs;
    }

    public onRowClicked(e) {
        console.log(e);
        if (e.event.target !== undefined) {
            let data = e.data;
            switch (e.event.target.id) {
                case "editAction":
                    {
                        //this.editClient(data['id'], data['name'], data['notes'], data['userName'], data['createdOn']);
                        this.edit(data['Id']);
                        break;
                    }

                case "deleteAction":
                    {
                        //this.editClient(data['id'], data['name'], data['notes'], data['userName'], data['createdOn']);
                        this.delete();
                        break;
                    }
            }
        }
    }

    edit(id: number) {
        console.log('edit', id);
        this.router.navigate(['/app/edit_360', id]);
    }

    delete() {
        console.log('delete');
    }
    
}
